// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-list_root__7IOB_","sizemd":"icon-list_sizemd__2_27i","sizelg":"icon-list_sizelg___giWZ"};